<script>
import store from '@/globals'

export default {
  name: 'Contact',
  data () {
    return {
      msg: 'Contact Information'
    }
  },
  mounted () {
    store.commit('menu')
  },
  updated () {
    store.commit('menu')
  },
  render (h) {
    return (
      <div id='app' class = 'container-fluid animated fadeIn'>
      
        {/*<div id = 'header'>
          <h1 class = 'text-left'>
            <strong>
              {this.msg}
            </strong>
          </h1>
        </div>*/}
        <div id = 'contactContent'>
          <div class = 'row p-3'>
            <h3 class = 'p-3' style = 'font-size: 20px;'>
              <strong>
                Contact now!
              </strong>
            </h3>
          </div>

          <div id = 'buttonDiv' class = 'row p-3'>
          
            <div class = 'links mx-3'>
              <a href = 'https://www.linkedin.com/in/erik-jackson-84407360' target = '_blank'>
                <button class = 'li-link btn' title = 'Linked In'>
                  <img class = 'li-btn ' src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/LinkedIn_logo_initials.png/900px-LinkedIn_logo_initials.png' /> 
                </button>
              </a>
            </div>

            <div class = 'links mx-3'>
              <a href = 'https://github.com/e-g-jackson' target = '_blank'>
                <button class = 'li-link btn' title = 'Git Hub'>
                  <img class = 'li-btn' src = 'static/imgs/GH-Mark.png' />
                </button>
              </a>
            </div>

            <div class = 'links mx-3'>
              <a href='mailto:jacks638@umn.edu'>
                <button id = 'email' class = 'btn btn-lg' title = 'Email'>
                  <i class = 'fas fa-envelope-square fa-3x'></i>
                </button>
              </a>
            </div>

          </div>
        </div>
      </div>
    )
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  button{
    color: #f6f7eb;
    background-color: #4ecdc4;
    width: 100%;
  }

  img {
    width: 100%;
    height: auto;
  }

  .links {
    width: 10%;
  }

  #app {
    background-color: #f6f7eb;
    color: #292f36;
    padding: 0px;
  }

  /* #buttonDiv {
    padding-right: 30%;
    padding-left: 30%;
  } */

  #contactContent {
    min-height: 500px
  }

  #header {
    background-color: #292f36;
    color: #4ecdc4;
    padding-bottom: 20px;
  }

  #header:hover {
    color: #ff6b6b;
  }

  @media screen and (max-width: 768px){
    .links {
      width: 100px;
      height: 100px;
    }

    #email {
      height: 88px;
    }
  }

  @media screen and (min-width: 768px){
    .links {
      width: 125px;
      height: 125px;
      padding: 10px;
    }

    #email {
      height: 93px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue